import Styled from 'styled-components';

export const NavButton = Styled.button`
  display: flex;
  color: ${({ theme: { link } }) => link.colorLink};

  text-decoration: ${({ theme }) => theme.globalAnchorDecoration};

  &:hover {
    color: ${({ theme: { link } }) => link.colorLinkHover};
  }
`;
